import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`text-xs uppercase tracking-luxe text-accent font-medium ${className}`}
  >
    {children}
  </span>
);
